export const featureFlags = {
  rideMapLiveTrackingStatuses: [],
};
